import { useHistory } from 'react-router-dom';
import { Hidden, Link, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import LoginSignUpBanner from 'pages/common/login-sign-up/login-sign-up-banner';

const useStyles = makeStyles(() => ({
  products: { display: 'flex', margin: 'auto', marginTop: '30px', marginBottom: '15px' },
  greeting: { color: '#8DA8B2' },
  signIn: { marginTop: '30px' },
  headingBox: { textAlign: 'center' },
}));

const Banner = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.headingBox}>
      <LoginSignUpBanner />
      <Typography variant="h5" className={classes.greeting}>
        Welcome back to Trustate
      </Typography>
      <Hidden mdDown>
        <img src={'/products.svg'} alt="Trustate Products" className={classes.products} />
      </Hidden>
      <div className={classes.signIn}>
        <Typography variant="h4" style={{ marginBottom: '20px' }}>
          Sign in
        </Typography>
        <Typography style={{ display: 'inline' }}>Don't have an account?</Typography>{' '}
        <Typography style={{ display: 'inline', textDecoration: 'underline', cursor: 'pointer' }}>
          <Link onClick={() => history.push('/sign-up')} data-cy="sign-up-link">
            Sign up
          </Link>
        </Typography>
      </div>
    </div>
  );
};

export default Banner;
